@if (isHost && social?.hostAdmitted && waitingUsers.length > 0) {
  <div class="waiting-content">
    <mat-expansion-panel hideToggle expanded (opened)="panelIndicator = true" (closed)="panelIndicator = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span
            >WAITING
            <span class="waiting-display"
              ><span class="waiting-text">{{ waitingUsers.length }}</span></span
            ></span
          >
          <img
            alt="arrow down"
            src="/assets/images/arrow_down.svg"
            style="float: right"
            class="panel-indicator"
            [class.open]="panelIndicator"
          />
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (waitingUsers.length > 1) {
        <div class="buttons-section">
          <a class="option-button admit-button" (click)="manageAllWaitingUsers(true, false)"> ADMIT ALL </a>
          <a class="option-button remove-button" (click)="manageAllWaitingUsers(false, true)"> REMOVE ALL </a>
          <br />
        </div>
      }
      @for (waitingUser of waitingUsers; track waitingUser) {
        <app-guest-admission [waitingUser]="waitingUser" [social]="social"></app-guest-admission>
      }
    </mat-expansion-panel>
  </div>
}
<div class="search-container m-b-8 flex items-center">
  <mat-icon>search</mat-icon>
  <input
    class="guests-search m-l-10 m-r-10"
    placeholder="Search Guests"
    [(ngModel)]="searchValue"
    (ngModelChange)="filterParticipants()"
  />
</div>
<div class="guests-container">
  <span class="guests-count uppercase font-s m-b-10"> IN THE ROOM ({{ filteredGuests.length }}) </span>
  @for (guest of filteredGuests; track guest; let i = $index) {
    <app-guest-info [guest]="guest" [even]="i % 2 === 0" [isHost]="isHost" [social]="social"></app-guest-info>
  }
</div>
